enum FahrberichteActions {
    FETCH_SETTINGS = "fahrberichteFetchSettings",
    CREATE_SETTING = "fahrberichteCreateSetting",
    UPDATE_SETTING = "fahrberichteUpdateSetting",
    DELETE_SETTING = "fahrberichteDeleteSetting",
    FETCH_TOPICS = "fahrberichteFetchTopics",
    CREATE_TOPIC = "fahrberichteCreateTopic",
    UPDATE_TOPIC = "fahrberichteUpdateTopic",
    DELETE_TOPIC = "fahrberichteDeleteTopic",
    REORDER_TOPICS = "fahrberichteReorderTopics",
}

enum FahrberichteMutation {
    SET_SETTINGS_RESULT = "fahrberichteSettingsResult",
    SET_TOPICS_RESULT = "fahrberichteTopicsResult",
}

export { FahrberichteActions, FahrberichteMutation };
